<template>
    <div>
        <b-row v-if="!printView || notes.length">
            <b-col class="header-menu-text">
                <h5 class="text-secondary">Notes</h5>
            </b-col>

            <b-col class="text-right" v-if="!printView">
                <b-dropdown ref="noteDropdown" text="Drop left" no-caret size="sm" variant="link" class="menu-btn" toggle-class="text-decoration-none" boundary="viewport" right>
                    <template #button-content>
                        <b-button variant="outline-secondary" size="sm">
                            <b-icon-plus></b-icon-plus>
                        </b-button>
                    </template>

                    <note @addNote="addNote(null, $event)"></note>
                </b-dropdown>
            </b-col>
        </b-row>

        <div v-if="!printView">
            <b-row v-if="!hasNotes">
                <b-col class="text-center">
                    <b-list-group>
                        <b-list-group-item variant="light">
                            <small><em>No Notes</em></small>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>
            </b-row>

            <b-row v-for="(note, index) in component" v-bind:key="'note-' + index" class="mb-3">
                <b-col>
                    <b-input-group size="sm" prepend="Type">
                        <b-input class="py-3" :value="noteType(note.type)" disabled></b-input>
                        <b-input-group-append v-if="note.username">
                            <b-button size="sm" :id="'noteuser-' + index" variant="outline-info">
                                <b-icon-person></b-icon-person>
                            </b-button>

                            <b-tooltip :target="'noteuser-' + index" triggers="hover">
                                {{ note.username }}
                            </b-tooltip>
                        </b-input-group-append>

                        <b-input-group-append v-if="note.date">
                            <b-button size="sm" :id="'notedate-' + index" variant="outline-info">
                                <b-icon-calendar4-event></b-icon-calendar4-event>
                            </b-button>

                            <b-tooltip :target="'notedate-' + index" triggers="hover">
                                {{ moment(note.date).format('M/D/YYYY h:mma') }}
                            </b-tooltip>
                        </b-input-group-append>
                        
                        <template #append>
                        <b-dropdown ref="existingNoteDropdown" no-caret size="sm" variant="outline-info" toggle-class="text-decoration-none" boundary="viewport" right>
                            <template #button-content>
                                <b-button class='editButton p-0' variant='outline-info' size="sm">
                                    <b-icon-pencil></b-icon-pencil>
                                </b-button>
                            </template>
                            <note :initialText='note.text' :initialType='note.type' :initialDate='note.date' @addNote="addNote(index, $event)" @removeNote="removeNote(index, $event)"></note>
                        </b-dropdown>
                    </template>
                        
                    </b-input-group>

                    <b-form-textarea size="sm"
                                     :value="note.text"
                                     max-rows="10"
                                     rows="2"
                                     disabled
                                     style="font-style: italic">
                    </b-form-textarea>

                </b-col>
            </b-row>
            <b-modal class="cancellationModal" id="cancellationReasonModal"
                hide-header-close
                no-close-on-backdrop
                scrollable
                button-size="sm"
                centered>
                <template #modal-header>
                Cancellation Reason Note
            </template>
             <b-form-textarea v-model="cancellationNoteText"
                no-close-on-backdrop
                rows="3"
                max-rows="8"
                placeholder="Enter a cancellation reason...">
             </b-form-textarea>
             <template #modal-footer="{  }">
                <b-button size="sm" class="mb-0" @click="addCancellationNote" variant="success" :disabled='!cancellationNoteText'>
                    <b-icon-check-square-fill></b-icon-check-square-fill>
                    <span class="p-xl-2 pl-2 pr-1">Add note</span>
                </b-button>
                <b-button size="sm" class="mb-0" @click="hideCancellationModal" variant="secondary">
                    <b-icon-x-square-fill></b-icon-x-square-fill>
                    <span class="p-xl-2 pl-2 pr-1">Discard</span>
                </b-button>
            </template>

            
        </b-modal>
        </div>

        <div v-else>
            <div v-for="(note, index) in component" v-bind:key="index" class="mb-3">
                <!--<b-row>-->
                    <!--<b-col sm="3">Amount</b-col>-->
                    <!--<b-col>{{ discount.amount }}</b-col>-->
                <!--</b-row>-->

                <b-row>
                    <b-col sm="3">Type</b-col>
                    <b-col>{{ note.type }}</b-col>
                </b-row>

                <b-row>
                    <b-col sm="3">Note</b-col>
                    <b-col>{{ note.text }}</b-col>
                </b-row>

                <b-row>
                    <b-col sm="3">Date</b-col>
                    <b-col>{{ moment(note.date).format('M/D/YYYY h:mma') }}</b-col>
                </b-row>

                <b-row>
                    <b-col sm="3">Username</b-col>
                    <b-col>{{ note.username }}</b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import arrayMixin from "../../mixins/array";
    import Note from "./Note";

    export default {
        name: "NoteList",
        props: [ 'notes', 'printView', 'newlyCancelled' ],
        mixins: [ arrayMixin ],
        components: { Note },
        created() {
            this.clone(this.notes);
        },
        data() {
            return {
                cancellationNoteText: null
            }
        },
        methods: {
            addNote(index, note) {
                if (!index && index !== 0) {
                    this.component.push(note);
                } 
                else {
                    const updatedArray = this.component.map((item, i) => i === index ? note : item);
                    this.component = updatedArray;
                }
                // this.$emit('update', note);
                this.closeDropdown(index);
            },
            removeNote(index) {
                this.component.splice(index, 1)
                this.closeDropdown(index);
            },
            noteType(type) {

                if (!type) {
                    return '';
                }

                if (type === 'cancellation') {
                    return "Cancellation Reason"
                }

                return type.charAt(0).toUpperCase() + type.slice(1);
            },
            closeDropdown(index) {
                if (!index && index !== 0) {this.$refs.noteDropdown.hide();}
                else {this.$refs.existingNoteDropdown[index].hide();}
            },
            hideCancellationModal() {
                this.cancellationNoteText = null;
                this.$bvModal.hide('cancellationReasonModal')
            },
            addCancellationNote() {
                const noteObj = {
                    username: this.$auth.user.nickname,
                    date: moment().format(),
                    type: 'cancellation',
                    text: this.cancellationNoteText,
                };
                this.addNote(null, noteObj);
                this.$bvModal.hide('cancellationReasonModal');
            },
                
        },
        computed: {
            hasNotes() {
                return this.component.length > 0
            }
        },
        watch: {
            notes() {
                this.component = this.notes;
            }
        }
    }
</script>

<style scoped>
    .editButton {
        border: none;
    }

    .input-group-text {
        width: 8rem;
    }

    .list-group-item {
        padding: 0.25rem .5rem;
    }
</style>